import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { LocationsProvider } from '../../providers/locations/locations';
import { DatabaseProvider } from '../../providers/database/database';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoLocationSelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-location-selector',
  templateUrl: 'co-location-selector.html',
})
export class CoLocationSelectorPage {

  selectedLocation: any;
  locationList: Array<any>;
  isRoam = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private events: Events, private locationProvider: LocationsProvider, private _db: DatabaseProvider, private _state: AppState) {
    this.isRoam = this._state.isRoam;
    this.selectedLocation = this._state.locationId;
    if (navParams.get('locations')) {
      this.locationList = navParams.get('locations');
    } else {
      this.locationProvider.getLocations().then(res => {
        if (res) {
          this.locationList = res;
        }
      });
    }
  }

  selectLocation() {
    this._db.get("staffCredentials").then((result) => {
      if (result){
        result["locationId"] = this.selectedLocation;
        console.log("result", result);
        // this._db.remove("staffCredentials");
        this._db.set("staffCredentials", result);
      }
    })
    this.events.publish('locationSelected', { id: this.selectedLocation });
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-location-selector/co-location-selector.ts